import React from "react";
import { Switch } from "react-router-dom";
import { connect } from "react-redux";
import PrivateRoute from "components/common/PrivateRoute";
import StoreTraits from "components/menu/master-files/store-traits/list";

const StoreTraitsRouter = props => (
    <div className="px-5">
        <Switch>
            <PrivateRoute
                exact
                path={`${props.match.url}/`}
                component={StoreTraits}
            />
        </Switch>
    </div>
);

export default connect()(StoreTraitsRouter);
